import React from 'react';
import { Link } from 'react-router-dom';
import { socialLinks } from '../data/mockData';
import { Instagram, Facebook, Linkedin, Youtube, AtSign } from 'lucide-react';

const iconMap = {
  Instagram,
  Facebook,
  Linkedin,
  Youtube,
  AtSign,
};

const Footer = () => {
  return (
    <footer className="bg-black border-t border-purple-900/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Logo/Brand */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-2xl font-bold text-transparent bg-gradient-to-r from-yellow-400 to-yellow-300 bg-clip-text">
              THE WISDOM NETWORK
            </h3>
            <p className="text-gray-400 mt-2">Powerful Guides for Your Growth. A Home for Your Journey.</p>
          </div>

          {/* Social Links */}
          <div className="flex space-x-6">
            {socialLinks.map((social) => {
              const IconComponent = iconMap[social.icon];
              
              return (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-purple-900/50 hover:bg-purple-800/70 border border-purple-700/50 hover:border-yellow-500/50 rounded-full flex items-center justify-center transition-all duration-300 hover:transform hover:scale-110 group"
                  aria-label={`Visit our ${social.name} page`}
                >
                  <IconComponent className="w-5 h-5 text-gray-400 group-hover:text-yellow-400 transition-colors duration-300" />
                </a>
              );
            })}
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-purple-900/30 text-center">
          <p className="text-gray-500 text-sm">
            Copyright © 2026 CMBC WELLNESS. All Rights Reserved.
          </p>
          <nav className="mt-4 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm" aria-label="Footer links">
            <Link className="text-gray-400 transition-colors hover:text-yellow-400" to="/privacy-policy">
              Privacy Policy
            </Link>
            <Link className="text-gray-400 transition-colors hover:text-yellow-400" to="/terms-conditions">
              Terms &amp; Conditions
            </Link>
            <Link className="text-gray-400 transition-colors hover:text-yellow-400" to="/contact">
              Contact
            </Link>
            <Link className="text-gray-400 transition-colors hover:text-yellow-400" to="/mcm">
              Mystic Circle Magazine
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;